import React from 'react';

import { QueueCallSessions } from 'src/lib/resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { QueueCallSession } from '@ragu-components/ord-types';

const QueueCallSessionsList = React.lazy(async () => import('./QueueCallSessionsList'));
const QueueCallSessionAgentEventsList = React.lazy(async () => import('./QueueCallSessionAgentEventsList'));
const QueueCallSessionEventsList = React.lazy(async () => import('./QueueCallSessionEventsList'));

export const queueCallSessionsResource: OrdResourceProps = {
  key: QueueCallSessions,
  name: QueueCallSessions,
  list: <QueueCallSessionsList />,
  edit: <QueueCallSessionAgentEventsList />,
  show: <QueueCallSessionEventsList />,
  options: {},
  recordRepresentation: (record: QueueCallSession): string => {
    return `${record.caller_id_name ?? ''} ${record.id}`.trim();
  },
};
